<template>
  <div>
    <h1>雪花算法ID生成</h1>
    <div style="max-width: 600px; margin-top: 20px;">
      <el-button type="primary" @click="getIds">生成ID</el-button>
      <p style="margin-top: 20px;"><strong>生成的ID列表：</strong></p>
      <el-input type="textarea" :rows="10" :value="ids.join('\n')" readonly></el-input>
    </div>
  </div>
</template>

<script>
import {snowflakeIdsFn} from '@/apis/menuSnowflakeApi'

export default {
  name: "MenuSnowflake",
  components: {},
  data() {
    return {
      ids: []
    }
  },
  methods: {
    getIds() {
      snowflakeIdsFn().then(res => {
        if (res.success) {
          this.ids = res.data
        } else {
          this.$message.error(res.msg || '操作失败')
          this.ids = []
        }
      }).catch(err => {
        this.$message.error(err.message || '操作失败')
        this.ids = []
      })
    }
  },
  mounted() {
    this.getIds()
  }
}
</script>

<style scoped>
</style>